export class LlmHealthCheck {
  public llmName: string;
  public clientName: string;
  public elapsedMs: number;
  public isHealthy: boolean;
  public errorMessage?: string;
  public createdAt: Date;

  constructor(data: any) {
    this.llmName = data.llmName;
    this.clientName = data.clientName;
    this.elapsedMs = data.elapsedMs;
    this.isHealthy = data.isHealthy;
    this.errorMessage = data.errorMessage;
    this.createdAt = new Date(data.createdAt);
  }
}
